import axiosInstance from "@/common/axiosInstance";
import apiCall from "./apiCall";
import { TCountryCode } from "countries-list";

export type Nomination = {
    id: string,
    sequenceID: string,
    sire: boolean,
    bire: boolean,
    vetting: boolean,
    inspectingCompanyId: string,
    companyName: string,
    inspectionDate: string,
    country: TCountryCode,
    requestDate: string,
    market: string,
    type: string,
    agentId: string,
    vesselId: string,
    shipOperatorId: string,
    shipOperatorName: string,
    typeOfvessel: string,
    typeOfvesselBire: string,
    vesselETA: string,
    portOfBerth: string,
    countryOfInspection: TCountryCode,
    portOfInspection: string,
    eta: string,
    etb: string,
    etd: string,
    operation: string,
    cargo: string,
    meansOfAccess: string,
    inspectorId: string,
    codeBook: string,
    inspectionFeeId: string,
    fee: number,
    awaitingDaysFee: number,
    nominationInspectorStatus: number,
    inspectorStatusNotes: string,
    nominationShipOperatorStatus: number,
    shipOperatorStatusNotes: string,
    generatedFileId: string,
    inspectionProcessStatus: number,
    inspectionProcess: number,
    inspectionProcessResultId: null,
    invoiceId: null,
    invoiceCompanyId: string,
    addCost: boolean,
    approvedBy: string,
    created: string,
    nameofVesselBire: string,
    vesselIdentifierTypeBire: string,
    vesselIdentifierBire: string,
    vesselIdBire: string
};

// Utility untuk menghindari undefined params
const qp = (v: any) => (v !== undefined && v !== null ? v : "");

const getListNominationAdmin = async (param: any) => {
    const query =
        `?search=${qp(param.search)}` +
        `&type=${qp(param.type)}` +
        `&pageNumber=${qp(param.pageNumber)}` +
        `&pageSize=${qp(param.pageSize)}` +
        `&market=${qp(param.market)}` +
        `&cancel=${qp(param.cancel)}` +
        `&inspectionStatus=${qp(param.inspectionStatus)}` +
        `&year=${qp(param.year)}` +
        `&month=${qp(param.month)}`;

    return apiCall("get", `/Nominations/GetAllNominationsAdmin${query}`);
};

const getListProcessAdmin = async (param: any) => {
    const query =
        `?search=${qp(param.search)}` +
        `&type=${qp(param.type)}` +
        `&pageNumber=${qp(param.pageNumber)}` +
        `&pageSize=${qp(param.pageSize)}` +
        `&inspectionStatus=${qp(param.inspectionStatus)}` +
        `&market=${qp(param.market)}` +
        `&year=${qp(param.year)}` +
        `&month=${qp(param.month)}`;

    return apiCall("get", `/Nominations/GetAllProcessAdmin${query}`);
};


const getListNominationInspectingCompany = async (param: any) => {
    const query =
        `?search=${qp(param.search)}` +
        `&id=${qp(param.id)}` +
        `&type=${qp(param.type)}` +
        `&pageNumber=${qp(param.pageNumber)}` +
        `&pageSize=${qp(param.pageSize)}` +
        `&year=${qp(param.year)}` +
        `&month=${qp(param.month)}`;

    return apiCall("get", `/Nominations/GetAllNominationsInspectingCompany${query}`);
};

const getListProcessInspectingCompany = async (param: any) => {
    const query =
        `?search=${qp(param.search)}` +
        `&id=${qp(param.id)}` +
        `&type=${qp(param.type)}` +
        `&pageNumber=${qp(param.pageNumber)}` +
        `&pageSize=${qp(param.pageSize)}` +
        `&year=${qp(param.year)}` +
        `&month=${qp(param.month)}`;

    return apiCall("get", `/Nominations/GetAllProcessInspectingCompany${query}`);
};


const getListNominationShipOperator = async (param: any) => {
    const query =
        `?search=${qp(param.search)}` +
        `&id=${qp(param.id)}` +
        `&type=${qp(param.type)}` +
        `&pageNumber=${qp(param.pageNumber)}` +
        `&pageSize=${qp(param.pageSize)}` +
        `&year=${qp(param.year)}` +
        `&month=${qp(param.month)}`;

    return apiCall("get", `/Nominations/GetAllNominationsShipOperator${query}`);
};

const getListProcessShipOperator = async (param: any) => {
    const query =
        `?search=${qp(param.search)}` +
        `&id=${qp(param.id)}` +
        `&type=${qp(param.type)}` +
        `&pageNumber=${qp(param.pageNumber)}` +
        `&pageSize=${qp(param.pageSize)}`;

    return apiCall("get", `/Nominations/GetAllProcessShipOperator${query}`);
};


const getNominationById = async (id: string) =>
    apiCall("get", `/Nominations/GetNominationById/${id}`);

const putStatusNominationInspectingCompany = async (data: any) =>
    apiCall("post", "/Nominations/UpdateStatusByInspectingCompany", data);

const putStatusProcessByInspectingCompany = async (data: any) => {
    const URL = "/Nominations/UpdateProcessByInspectingCompany";
    try {
        const response = await axiosInstance.post(URL, data, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (err: any) {
        return {
            status: err?.response?.status,
            message: err?.response?.data?.message,
        };
    }
};

const putStatusNominationShipOperator = async (data: any) => {
    const URL = "/Nominations/UpdateStatusByShipOperator";
    try {
        const response = await axiosInstance.post(URL, data, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (err: any) {
        return {
            status: err?.response?.status,
            message: err?.response?.data?.message,
        };
    }
};

const putNomination = async (data: any) =>
    apiCall("post", "/Nominations/Update", data);

const postNomination = async (data: any) =>
    apiCall("post", "/Nominations/Create", data);

const cancelNomination = async (data: any) =>
    apiCall("post", "/Nominations/CanceledNominationByShipOperator", data);

const deleteNomination = async (obj: any) =>
    apiCall("post", "/Nominations/Delete", obj);


export {
    deleteNomination,
    postNomination,
    cancelNomination,
    putNomination,
    getNominationById,
    getListNominationAdmin,
    getListNominationInspectingCompany,
    getListNominationShipOperator,
    getListProcessAdmin,
    getListProcessInspectingCompany,
    getListProcessShipOperator,
    putStatusNominationInspectingCompany,
    putStatusNominationShipOperator,
    putStatusProcessByInspectingCompany,
};
